import React from "react";

const Contact = () => {
  return (
    <>
      <div className="card shadow-none">
        <div className="card-body">
          <h5 className="fs-18 mb-3">Tại sao nên đặt phòng với chúng tôi</h5>
          <div>
            <p className="d-flex align-items-center mb-3">
              <i className="isax isax-medal-star text-primary me-2"></i>
              Chuyên môn và kinh nghiệm
            </p>
            <p className="d-flex align-items-center mb-3">
              <i className="isax isax-menu text-primary me-2"></i>Dịch vụ được
              thiết kế riêng
            </p>
            <p className="d-flex align-items-center mb-3">
              <i className="isax isax-message-minus text-primary me-2"></i>
              Kế hoạch toàn diện
            </p>
            <p className="d-flex align-items-center mb-3">
              <i className="isax isax-user-add text-primary me-2"></i>Khách hàng
              Sự hài lòng
            </p>
            <p className="d-flex align-items-center">
              <i className="isax isax-grammerly text-primary me-2"></i>Hỗ trợ
              24/7
            </p>
          </div>
        </div>
      </div>
      <div className="card shadow-none">
        <div className="card-body">
          <h5 className="fs-18 mb-3">Hỏi chúng tôi</h5>
          <div className="banner-form">
            <form action="https://dreamstour.dreamstechnologies.com/html/tour-details.html">
              <div className="mb-3">
                <label className="form-label">Tên</label>
                <input type="text" className="form-control" />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input type="text" className="form-control" />
              </div>
              <div className="mb-3">
                <label className="form-label">Điện thoại</label>
                <input type="text" className="form-control" />
              </div>
              <div className="mb-3">
                <label className="form-label">Tin nhắn</label>
                <textarea className="form-control" rows="3"></textarea>
              </div>
              <button
                type="submit"
                className="btn btn-primary btn-lg search-btn ms-0 w-100 fs-14"
              >
                Gửi yêu cầu
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
